export default "__VITE_ASSET__DQb7iFUH__"